var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
const StyledTextArea = styled.textarea `
  padding: 1rem 1.3rem;
  background-color: #fff;
  border-radius: 4px;
  border: 2px solid #d7dae0;
  color: inherit;
  font-weight: 400;
  resize: ${({ isResizable }) => isResizable ? 'both' : 'none'};
`;
const TextArea = (_a) => {
    var { className, isResizable = false, onClick, onChange, value } = _a, otherProps = __rest(_a, ["className", "isResizable", "onClick", "onChange", "value"]);
    return (React.createElement(StyledTextArea, Object.assign({ className: className, isResizable: isResizable, onClick: onClick, onChange: onChange, value: value }, otherProps)));
};
export { TextArea };
